import Svg, {Path} from 'react-native-svg';

const ChevronIcon = () => (
  <Svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <Path d="M16 3L7 12L16 21" stroke="#FF9500" strokeWidth={2} />
  </Svg>
);

export default ChevronIcon;
